import React, { useState, useMemo } from 'react';
import { AddAppointment, Container1, Container2, BoxContainer, BoxInner1, InnerAppointments, Text, Texts, DataContainer, StatusData, LineContainer, MenuContainer, PagingContainer, InnerBox } from './Styles';
import { ReactComponent as Add } from '../../../../../../src/assets/images/add-square.svg';
import InputSelect from 'src/components/shared/Form/Select';
import { ReactComponent as MenuIcon } from '../../../../../assets/images/more.svg';
import theme from 'src/config/theme';
import { Chip } from '@mui/material';
import Paging from 'src/components/App/Paging';
import NoDataFound from '../../NoDataFound/NoDataFound';
import AppointmentTabForm from '../Forms/AppointmentTabForm';
import DialogBox from 'src/components/shared/Dialog/DialogBox';

const AppointmentCard = ({ appointments = [], page, perPage, setPage, totalCount, fetchAppointments }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const sortOptions = [
        { label: 'Date & Time (Newest First)', value: 'date_desc' },
        { label: 'Date & Time (Oldest First)', value: 'date_asc' },
        { label: 'Status (A-Z)', value: 'status_asc' },
        { label: 'Status (Z-A)', value: 'status_desc' },
    ];



    const formatTime = (time) => {
        if (typeof time === 'string' && !time.includes('T')) return time;
        try {
            const dateObj = new Date(time);
            return dateObj.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        } catch (e) {
            return 'Invalid Time';
        }
    };

    const data = appointments.map((appointment) => ({
        appointmentId: appointment.id,
        symptoms: appointment.addnotes || "No symptoms provided",
        status: (
            <Chip
                label={appointment.recordStatus}
                sx={{
                    background:
                        appointment.recordStatus === "Scheduled" ? "linear-gradient(0deg, rgba(150, 57, 150, 0.12), rgba(150, 57, 150, 0.12))" :
                            appointment.recordStatus === "In Queue" ? "linear-gradient(0deg, rgba(103, 57, 150, 0.14), rgba(103, 57, 150, 0.14))" :
                                appointment.recordStatus === "Attending Now" ? "linear-gradient(0deg, rgba(57, 150, 57, 0.18), rgba(57, 150, 57, 0.18))" :
                                    appointment.recordStatus === "Complete" ? "linear-gradient(0deg, rgba(57, 150, 57, 0.18), rgba(57, 150, 57, 0.18))" :
                                        appointment.recordStatus === "Cancelled" ? "linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18))" :
                                            appointment.recordStatus === "Overdue" ? "linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18))" :
                                                appointment.recordStatus === "Treatment Scheduled" ? "linear-gradient(0deg, rgba(150, 57, 150, 0.12), rgba(150, 57, 150, 0.12))" :
                                                    "linear-gradient(0deg, rgba(200, 200, 200, 0.18), rgba(200, 200, 200, 0.18))",
                    color:
                        appointment.recordStatus === "Scheduled" ? theme.palette.action.purpleDark :
                            appointment.recordStatus === "In Queue" ? theme.palette.action.purpleLight :
                                appointment.recordStatus === "Attending Now" ? theme.palette.action.green :
                                    appointment.recordStatus === "Complete" ? theme.palette.action.green :
                                        appointment.recordStatus === "Cancelled" ? theme.palette.action.red :
                                            appointment.recordStatus === "Overdue" ? theme.palette.action.red :
                                                appointment.recordStatus === "Treatment Scheduled" ? theme.palette.action.purpleDark :
                                                    theme.palette.gery.black,
                    ...theme.typography.small,
                    borderRadius: '100px',
                    padding: '8px 18px 8px 18px',
                }}
            />
        ),
        appointments: new Date(appointment.date).toLocaleDateString('en-GB', {
            day: '2-digit', month: 'short', year: 'numeric'
        }) + `, ${formatTime(appointment.time)}`
    }));

    return (
        <>
            <Container1>
                <AddAppointment
                    startIcon={<Add width="18px" height="18px" />}
                    onClick={handleOpen}
                >
                    Add Appointment
                </AddAppointment>

            </Container1>
            <Container2>
                <InnerAppointments>

                    <InnerBox isEmpty={data.length === 0}>
                        {data.length === 0 ? (
                            <NoDataFound
                                title="No Appointments Found!"
                                buttonText="Add Appointment"
                                buttonIcon={Add}
                                onClick={handleOpen}
                            />
                        ) : (
                            <>
                                {data.map((item) => (
                                    <BoxContainer key={item.appointmentId}>
                                        <BoxInner1>
                                            <DataContainer>
                                                <Text>{item.appointments}</Text>
                                                <Texts>Date & Time</Texts>
                                            </DataContainer>
                                            <StatusData>{item.status}</StatusData>
                                        </BoxInner1>
                                        <LineContainer />
                                        <BoxInner1>
                                            <DataContainer>
                                                <Text>{item.symptoms}</Text>
                                                <Texts>Symptoms</Texts>
                                            </DataContainer>
                                            <MenuContainer>
                                                <MenuIcon />
                                            </MenuContainer>
                                        </BoxInner1>
                                    </BoxContainer>
                                ))}
                            </>
                        )}

                    </InnerBox>
                    <PagingContainer>
                        <Paging
                            page={page}
                            perPage={perPage}
                            count={totalCount || 0}
                            onChange={(newPage) => setPage(newPage)}
                        />
                    </PagingContainer>
                </InnerAppointments>
                <DialogBox open={open} onClose={handleClose} >
                    <AppointmentTabForm onClose={handleClose} fetchAppointments={fetchAppointments} />
                </DialogBox>

            </Container2>
        </>
    );
};

export default AppointmentCard;



